import _ from "lodash";
import QueryEmployeeTransports from "graphql/queries/QueryEmployeeTransports";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchEmployeeTransport {
	
	static fetch( { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'employee_transports', QueryEmployeeTransports, {
			variables: {
				date: [ HelperDate.date().format( dateFormat.DATE ) ]
			},
			resultPath: [ 'employee_transports' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( dispatchDataToStore ) {
					store.dispatch( addDataByGuid( dataConstants.EMPLOYEE_TRANSPORTS, result ) );
				}
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						employeeTransports: result
					});
				}
			}
		})
	}
}
